"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doLogout = doLogout;
exports.logout = logout;

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

function doLogout() {
  return new _promisePolyfill.default(function (resolve) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'logout', true);

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        _SiteLayout.default.current.navigate(_SiteLayout.default.current.props.homeLink, false, function () {
          resolve(true);
        });
      }
    };

    xhr.send();
  });
}

function logout() {
  return doLogout().then(function () {
    location.reload();
  });
}